import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const SubTabContent = styled.div`
    width: 100%;
    min-height: 322px;
    padding: 32px 24px 24px;

    background: ${Colors.WHITE};
    border-bottom-right-radius: 1px;
    border-bottom-left-radius: 1px;
`;
